import api from '../../api';
import models from '../../../models';
import output from '../../../utils/output-writer';
import { WrappedRegisterToolFuncType } from '../tool-definition';
import { createCallToolResult, createTextContent } from '../output-parser';

const getAlertInputSchema = models.tool.getAlertInput;

export function setup(register: WrappedRegisterToolFuncType) {
  register(
    'get-alert',
    {
      title: 'Get Alert',
      description:
        'Given a Slack or Teams message link, returns the parsed alert, the matched book name, and the variables map. No playbook actions are run.\n\n' +
        'alert.isSupported false means the message was fetched but is not a parsable alert\n\n' +
        'when an alert is found but no deployed book matches it, `book` will be `null`.',
      inputSchema: getAlertInputSchema,
    },
    async (input) => {
      output.info(`Getting parsed alert for ${input.messageLink}`);

      const result = await api.getAlert(input);

      return createCallToolResult({
        contentBlocks: [createTextContent(JSON.stringify(result, null, 2))],
      });
    }
  );
}

export default { setup };
